import React, { useState } from 'react';

const NavScrollContext = React.createContext();

export function NavScrollProvider({ children }) {
  const [navScroll, setNavScroll] = useState(0);

  // NEW: modal state
  const [isModalOpen, setIsModalOpen] = useState(false);

  // NEW: current photo inside modal
  const [modalPhoto, setModalPhoto] = useState(null);

  return (
    <NavScrollContext.Provider value={[navScroll, setNavScroll]}>
      {children}
    </NavScrollContext.Provider>
  );
}

export default NavScrollContext;